import { render, staticRenderFns } from "./InterviewAnswerImage.vue?vue&type=template&id=ae3b50a6&scoped=true"
import script from "./InterviewAnswerImage.vue?vue&type=script&lang=js"
export * from "./InterviewAnswerImage.vue?vue&type=script&lang=js"
import style0 from "./InterviewAnswerImage.vue?vue&type=style&index=0&id=ae3b50a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3b50a6",
  null
  
)

export default component.exports